/** Nested workflow metadata from `patient-encounter/v2/patient/encounter/metaData` (see buildWorkflowMetadata). */
export type WorkflowSubStatusMetaData = {
  workflowSubStatusId: number
  workflowStatusId?: number
  workflowSubStatusDesc?: string
  /** Guidance text from encounter metaData (`next_steps` in DB). */
  nextSteps?: string
  [key: string]: unknown
}

export type WorkflowStatusMetaData = {
  workflowStatusId: number
  workflowId?: number
  statusName?: string
  workflowStatusDesc?: string
  /** Guidance text at primary-status level (`next_steps` on workflow_status). */
  nextSteps?: string
  workflowSubStatus: WorkflowSubStatusMetaData[]
  [key: string]: unknown
}

/** One workflow (e.g. Preconverted / Converted) with nested statuses. */
export type WorkflowMetaData = {
  workflowId: number
  workflowName?: string
  workflowStatus: WorkflowStatusMetaData[]
  [key: string]: unknown
}

export type TimingRiskMetaData = {
  timingRiskId: number
  timingRiskName: string,
  shortName: string
}

export type PaymentChannelMetaData = {
  paymentChannelId: number
  paymentChannelName: string,
  shortName: string
}


export class TimingRisk {
  timingRiskId!: number;
  timingRiskName!: string;
  shortName!: string
}

export type CRMObjectTypeMetaData = {
  crmObjectTypeId: number;
  crmTypeId: number;
  crmObjectTypeSlug: string;
  crmObjectApiName: string;
  crmObjectName: string;
}

export type CRMTypeMetaData = {
  crmTypeId: number;
  crmTypeSlug: string;
  crmName: string;
}

export type RuleParamsMetadata = {
  ruleParamId: number,
  paramName: string,
  paramPropertyName: string,
  dataType: string,
  comparators: string,
  isList: boolean,
  sortOrder: number,
}

export type Alert = {
  client_alert_id: number;
  alert_ref_id: string;
  alert_type_id: number;
  note_title: string | null;
  note_body: string;
  client_employer_id: number | null;
  employer_name: string | null;
  group_code: string | null;
  payor_id: number | null;
  payor_name: string | null;
  client_prefix_id: number | null;
  prefix: string | null;
}

export type Employer = {
  clientEmployerId: number;
  fpClientId: number;
  fpFacilityId: number | null;
  employerName: string;
}

export type EmploymentStatus = {
  employmentStatusId: number
  employmentStatus: string
  employmentStatusSlug: string
  enableCapacityToPay: boolean
}

export type Alerts = {
  [key: number] : {
    payer: Alert[];
    prefix: Alert[];
    group: Alert[];
    employer: Alert[]
  }
}

export type Employers = {
  [key: number] : Employer[]
}

export const emptyAlerts = {
  0: {
    payer: [],
    prefix: [],
    group: [],
    employer: []
  }
}

export const emptyEmployers = {
  0: []
}

export interface VobSource {
    vobSourceId: number;
    name: string;
    slug: string;
}

export interface SubscriberRelation {
  subscriberRelationId: number,
  subscriberRelation: string
}

export interface EducationLevel {
  educationLevelId: number
  educationLevel: string
  educationLevelSlug: string
}

export interface MetaDataState {
  paymentChannel: PaymentChannelMetaData[],
  timingRisk: TimingRiskMetaData[],
  crmObjectType: CRMObjectTypeMetaData[],
  crmType: CRMTypeMetaData[],
  alerts: Alerts,
  employers: Employers,
  ruleParams: RuleParamsMetadata[],
  vobSource: VobSource[]
}

const initialState: MetaDataState = {
  paymentChannel: [],
  timingRisk: [],
  crmObjectType: [],
  crmType:[],
  alerts: emptyAlerts,
  employers: emptyEmployers,
  ruleParams: [],
  vobSource: []
};